import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';

import MoreActionsSvg from '../../../assets/more-actions.svg';
import MoreActionsActiveSvg from '../../../assets/more-actions-active.svg';

import styles from '../../styles/views/components/MoreActions.module.scss';

const MoreActions = ({ actions }) => {
  const [showActions, setShowActions] = useState(false);

  const handleOnIconClick = useCallback(() => {
    setShowActions(prev => !prev);
  }, [setShowActions]);

  return (
    <div className={styles.wrapper}>
      <div onClick={handleOnIconClick}>
        {showActions ? <MoreActionsActiveSvg /> : <MoreActionsSvg />}
      </div>
      {showActions && (
        <div className={styles.actions}>
          {actions.map(({ title, onClick }) => (
            <div
              className={styles.action}
              key={title}
              onClick={() => {
                setShowActions(false);
                onClick();
              }}
            >
              {title}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

MoreActions.propTypes = {
  actions: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    onClick: PropTypes.func,
  })).isRequired,
};

export default MoreActions;
